import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import MoviePlayerModal from 'components/MoviePlayerModal/MoviePlayerModal'
import Loader from 'components/Loader/Loader'
import { getMovie, getMovieEpisodes } from 'service/MovieService'

const MoviePlayerPage = () => {
  const { mediaId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  const [movie, setMovie] = useState(location.state?.movie || null)
  const [episodes, setEpisodes] = useState(Array.isArray(location.state?.episodes) ? location.state.episodes : [])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const loadPlayerData = async () => {
      try {
        setLoading(true)
        setError('')

        let nextMovie = movie
        if (!nextMovie) {
          nextMovie = await getMovie(mediaId)
        }

        let nextEpisodes = episodes
        const episodesResponse = await getMovieEpisodes(mediaId)
        const episodesData = episodesResponse?.data?.results || episodesResponse?.data || []
        if (Array.isArray(episodesData)) {
          nextEpisodes = episodesData
        }

        setMovie(nextMovie)
        setEpisodes(Array.isArray(nextEpisodes) ? nextEpisodes : [])
      } catch (loadError) {
        console.error('Error loading movie player page:', loadError)
        setError('Не удалось загрузить плеер фильма')
      } finally {
        setLoading(false)
      }
    }

    loadPlayerData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediaId])

  const initialEpisode = useMemo(() => {
    const requestedEpisode = new URLSearchParams(location.search).get('episode')
    if (!requestedEpisode || episodes.length === 0) {
      return episodes[0] || null
    }

    return (
      episodes.find((episode) => String(episode.id) === requestedEpisode)
      || episodes.find((episode) => String(episode.episode_number) === requestedEpisode)
      || episodes[0]
      || null
    )
  }, [episodes, location.search])

  if (loading) {
    return (
      <div style={{ minHeight: '50vh', display: 'grid', placeItems: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <Loader size="large" />
          <p>Загрузка плеера...</p>
        </div>
      </div>
    )
  }

  if (error || !movie) {
    return (
      <div style={{ minHeight: '50vh', display: 'grid', placeItems: 'center', textAlign: 'center' }}>
        <div>
          <h2>{error || 'Фильм не найден'}</h2>
          <button type="button" onClick={() => navigate(-1)}>
            Назад
          </button>
        </div>
      </div>
    )
  }

  return (
    <MoviePlayerModal
      movie={movie}
      episodes={episodes}
      initialEpisode={initialEpisode}
      onClose={() => navigate(-1)}
      onEpisodeChange={() => {}}
      asPage
    />
  )
}

export default MoviePlayerPage
